import ReactApexChart from "react-apexcharts";
import React from "react";
import {DarkStoreType} from "../../../common/types";

// Тип пропсов для компонента, ожидается массив данных по дарксторам
type DrugsPropsType = {
    data: DarkStoreType[]
}

// Основной компонент для отображения доли аптечных товаров
export const Drugs = ({data}: DrugsPropsType) => {
    // Переменная для хранения общего количества товаров
    let countGoods = 0
    // Переменная для хранения количества аптечных товаров
    let countDrugs = 0

    // Перебор массива данных и подсчёт количества товаров и аптечных товаров
    data.forEach((el) => {
        countGoods += el.kol_vo_tovarov
        countDrugs += el.kol_vo_tovarov_iz_apteki
    })

    // Массив значений для графика (аптечные и остальные товары)
    const series = [countDrugs, countGoods]
    // Опции для круговой диаграммы ApexCharts
    const options = {
        chart: {
            width: 380,
            type: 'pie' as const,
        },
        title: {
            text: 'Доля аптечных товаров',
            align: 'center' as const,
            margin: 20,
            style: {
                fontSize: '16px',
                fontWeight: 'bold' as const,
                color: '#FFFFFF'
            },
        },
        labels: ['Аптечные товары', 'Остальные товары'],
        legend: {
            labels: {
                colors: '#FFFFFF'
            },
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 200
                },
                legend: {
                    position: 'bottom'
                }
            }
        }]
    }

    // Рендерим круговую диаграмму по доле аптечных товаров
    return (
        <div>
            <ReactApexChart
                options={options}
                series={series}
                type={'pie'}
                height={500}
                style={{color: '#FFFFFF'}}
            />
        </div>
    );
};
